// TimeNotSyncWithServerModal.js
import { connect } from 'react-redux';

import TimeNotSyncWithServerModal from '../component/TimeNotSyncWithServerModal.jsx';

import getExternalData from '../selector/getExternalData.js';
import getTimestampOffset, {
  Accuracy,
} from '../selector/getTimestampOffset.js';

import toggleModal from '../action/toggleModal.js';

const mapStateToProps = state => {
  return {
    clientTimestamp: getExternalData(state, ['timestamp'], 'client'),
    serverTimestamp: getExternalData(state, ['timestamp'], 'server'),
    timeOffsetSecondsWithServer: getTimestampOffset(state, Accuracy.SECOND),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    toggleModal: payload => dispatch(toggleModal(payload)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TimeNotSyncWithServerModal);
